import { useClassNames } from 'hooks/useClassNames';
import React, { useMemo } from 'react';
import * as iconsLibrary from '../../Icon/icons.library';
import { PSelectButtonV2Style as S } from './PSelectButtonV2.style';
import { SelectButton, SelectButtonProps } from 'primereact/selectbutton';
import { HStack } from 'components/layouts/primitives/Stack/Stack';
import { Text } from 'components/Text/Text';
import { Icon } from 'components/Icon/Icon';

type SelectButtonOptionType = {
  label?: string;
  value?: any;
  disabled?: boolean | undefined;
  iconLeft?: keyof typeof iconsLibrary;
};

const SelectButtonItem: React.FC<{ item: SelectButtonOptionType }> = ({ item }) => {
  return (
    <HStack stretch gap="gap2" align="center" justify="center" fit="space">
      {!!item.iconLeft && <Icon className="p-button-icon" icon={item.iconLeft} size={16} />}
      {!!item.label && (
        <Text
          className="p-button-label"
          fit="content"
          size="fontSizeXS"
          lineHeight="lineHeightSM"
          weight="medium"
        >
          {item.label}
        </Text>
      )}
    </HStack>
  );
};

export const PSelectButtonV2 = React.forwardRef<
  SelectButton,
  Omit<SelectButtonProps, 'size' | 'options'> & {
    options: SelectButtonOptionType[];
    fullWidth?: boolean;
  }
>((props, ref) => {
  const cleanProps = useMemo(() => (({ fullWidth, ...o }: any) => o)(props), [props]);

  const classNames = useClassNames(
    {
      'full-width': props.fullWidth,
    },
    props.className
  );

  return (
    <S.SelectButton
      ref={ref}
      {...cleanProps}
      unselectable={false}
      className={classNames}
      itemTemplate={(item) => <SelectButtonItem item={item} />}
    />
  );
});
